<template>
  <v-card
    tile
    class="mtfont"
  >
    <v-dialog
        v-model="dialog"
        max-width="600px"
    >
      <FormulaCard />
    </v-dialog>

    <v-container class="pa-6" id="FormulaPrintArea">
      <v-toolbar dense flat>
        <v-toolbar-title>Saved Formulas</v-toolbar-title>
      </v-toolbar>
    
      <v-simple-table style="border: 1px solid lightgrey;" class="mt-2">
          <template>
            <thead>
              <tr>
                <th class="text-left">
                  ACTIONS
                </th>
                <th class="text-left">
                  CODE
                </th>
                <th class="text-left">
                  COLOR
                </th>
                <th class="text-left">
                  NAME
                </th>
                <th class="text-right">
                  VERSION
                </th>
              </tr>
            </thead>
            <tbody>
            <tr v-if="!colors.length">
              <td>No Favorites Found...</td>
            </tr>
              <tr
                v-for="item in colors"
                :key="item.code"
                style="cursor: pointer;"
              >
                <td width="80px">
                  <table><tr>
                    <td>
                        <v-btn icon small class="ml-1" v-on:click="deleteFormula(item)"><v-icon>delete</v-icon></v-btn>
                    </td>
                    <td>
                      <UserEditFormulaModal :selectedItem="item" />
                    </td>
                  </tr></table>

                  </td>
                <td width="20px" v-on:click="selectFavorite(item)">{{ item.color.code }}</td>
                <td width="20px" v-on:click="selectFavorite(item)"> <LighteningBoltIndicater :hexColor="item.color.hex" /> </td>
                <td v-on:click="selectFavorite(item)">{{ item.customName || item.color.name }}</td>
                <td class="text-right" v-on:click="selectFavorite(item)">{{ item.version? versionToDate(item.version): '' }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      <small v-if="colors.length">*click formula to display details</small>
    </v-container>
  </v-card>
</template>

<script>
  import LighteningBoltIndicater from '@/components/Admin/LighteningBoltSwatch.vue';
  import FormulaCard from '@/components/Account/FavoriteFormulaCard.vue';
  import UserEditFormulaModal from '@/components/Account/UserEditFormulaModal.vue';

  export default {
    name: 'FormulaTable',
    
    components: {
      LighteningBoltIndicater,
      FormulaCard,
      UserEditFormulaModal
    },

    data: () => ({
      searchText: '',
      colorModal: true,
      pages: 1,
      currentPage: 1,
      colors: [],
      loadingText: 'Loading...',
      dialog: false
    }),
    created() {
      this.$store.dispatch('getUserFavorites')
              .then(results => {
                this.colors = this.$store.getters.getUserFavorites || [];
                console.log('ALL_USER_FAVORITES', this.colors)
              })
              .catch(error => console.error("ERROR", error));
    },
    methods: {
      selectFavorite(item) {
        console.log('SELECTED_FAVORITE', item);
        this.$store.dispatch('setCurrentFavorite', item);
        console.log('CURRENT_FAVORITE', this.$store.getters.getCurrentUserFavorite);
        this.dialog = !this.dialog;
      },
      versionToDate: function(value) {
        return new Date(+value).toLocaleDateString();
      },
      deleteFormula: function(favorite) {
        if(!confirm('Delete Formula?')) return;
        const formulaFavorite = {
          color: favorite.color.id || '',
          formula: favorite.formula.id,
          version: favorite.version
        };

        console.log('REMOVE_LOG', JSON.stringify(formulaFavorite))

        this.$store.dispatch('removeFormulaFavorite', formulaFavorite)
          .then(results => {
            this.$store.dispatch('getUserFavorites')
                .then(() => { this.colors = this.$store.getters.getUserFavorites; console.log('ALL_USER_FAVORITES', this.colors) })
                .catch(error => console.error("ERROR", error));
          })
          .catch(e => console.error(e));
      },
      editItem(item) {
        window.open('/edit/' + item, "_self");
      },
      printDiv: function() { 
        var divContents = document.getElementById("FormulaPrintArea").innerHTML; 
        var a = window.open('', '', 'height=600, width=900'); 
        a.document.write('<html><body>'); 
        a.document.write(divContents); 
        a.document.write('</body></html>'); 
        a.document.close();
        a.print(); 
        a.close();
      }
    }
  }
</script>

<style scoped>
.pagination-text {
  color: grey;
  font-size: small;
  padding-top: 8px;
}
</style>